import { getAuthUser } from "../lib/effectiveAuthUser";
import Auth from "../Auth.js";
import firebase from "../Firebase.js";
import { useCommentStore } from "../stores/commentStore.js";

/**
 * Static utility methods for user display names used by comments
 */
class DisplayName {
  static async _updateAnonymousUserName(name) {
    await firebase.auth().currentUser.updateProfile({
      displayName: name,
    });
  }

  static async _updateRegisteredUserName(name) {
    const result = await Auth.fetchWithIdToken("/api/profiles/me", {
      method: "PUT",
      displayName: name,
    });
    if (!result.success) {
      throw new Error(result.error);
    }
  }

  static async get() {
    const user = getAuthUser();
    // Comment UI may mount before an admin session has a validated target.
    if (!user) return "";
    const treatAsAnonymous = useCommentStore.getState().treatAsAnonymous;
    if (user.isAnonymous || treatAsAnonymous) {
      return user.displayName;
    } else {
      const result = await Auth.fetchWithIdToken(`/api/profiles/me`);
      return result?.profile?.displayName || user.displayName || "";
    }
  }

  static async update(displayName) {
    const user = getAuthUser();
    // Never fall back to mutating the raw synthetic credential's profile.
    if (!user) throw new Error("Sign in before changing your display name.");
    const treatAsAnonymous = useCommentStore.getState().treatAsAnonymous;

    if (user.isAnonymous || treatAsAnonymous) {
      await this._updateAnonymousUserName(displayName);
    } else {
      await this._updateRegisteredUserName(displayName);
    }
    return displayName;
  }

  static async assignRandom(documentId) {
    const name = await Auth.fetchWithIdToken(`/api/anonymous-names/new`, { documentId });
    return await this.update(name.anonymousName);
  }

  static async getRandom(documentId) {
    const name = await Auth.fetchWithIdToken(`/api/anonymous-names/new`, { documentId });
    return name.anonymousName;
  }
}

export default DisplayName;
